export const DEFAULT_FT_RADIUS = 250;
